<template>
  <div class="ma-11">
    <v-row justify="start" align="center">
      <v-icon left>mdi-history</v-icon>
      <span class="grey--text title">Histori Diagnosa</span>
      <v-spacer></v-spacer>
    </v-row>
    <v-divider class="mt-5 mb-11"></v-divider>
    <v-card class="pa-3">
      <v-data-table
        :loading="loading"
        :items="data"
        :headers="header"
        no-data-text="Belum ada data"
        loading-text="Memuat data ...."
      >
        <template v-slot:item.nomorhp="{item}">
          <v-chip small dark color="primary">q12  
            <span>{{item.nomorhp}}</span>
          </v-chip>
        </template>

        <template v-slot:item.alamat="{item}">
          <span class="grey--text caption">{{item.alamat}}</span>
        </template>

        <template v-slot:item.penyakit="{item}">
          <v-chip small dark color="error">
            <span
              class="white--text caption"
            >{{item.penyakit.nama + ' (' + item.penyakit.keterangan + ' )'}}</span>
          </v-chip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>
<script>
import fs from "@/fb";
export default {
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData: async function() {
      this.data = [];
      this.loading = true;
      const r = await fs.diagnosa.get();
      r.docs.forEach(async doc => {
        const data = doc.data();
        const rp = await fs.penyakit
          .where("kode", "==", data.penyakit)
          .limit(1)
          .get();
        const p = rp.docs[0];
        const penyakit = {
          ...p.data(),
          id: p.id
        };
        this.data.push({
          ...data,
          penyakit: penyakit
        });
      });
      this.loading = false;
    }
  },
  data() {
    return {
      data: [],
      tampil: true,
      loading: false,
      header: [
        {
          text: "Nomor Handphone",
          value: "nomorhp"
        },
        {
          text: "Nama Petani",
          value: "nama"
        },
        {
          text: "Alamat Lengkap",
          value: "alamat"
        },
        {
          text: "Penyakit",
          value: "penyakit"
        }
      ]
    };
  }
};
</script>